/**
 * PATH: packages/job-hub/src/jobs/qa/itpLibraryName.ts
 * FILE_ID: JOBHUB-QA-ITP-LIBRARY-NAME-001
 * PURPOSE: Default name for a saved ITP freeze.
 */

export function defaultItpLibraryName(areaNames: string[]): string {
  if (areaNames.length === 1) return `${areaNames[0].slice(0, 196)}_ITP`
  return 'ITP'
}
